module.exports = __webpack_public_path__ + "img/assignment_logo.179e0ae0.png";